
$(document).ready(function () {
  window.clickedFromPopupColor = false;
  function initHeaderAndSticky() {
    var $header = $("header");
    var lastScroll = 0;

    var $filterMobile = $(".filter-mobile-block");
    var $allProductsHead = $(".all-products-head");
    var $mediaGroup = $(".product-single__media-group-wrapper");
    var $anchorParent = $(".anchor-menu-section").parent();
    var $compareMobile = $(".compare-section__products-mobile");
    var $compareDesktop = $(".compare-section__products");
    var $standingContent = $(".standing-desks__content");

    $header.addClass("nav-down");
    $('.compare_three-desks-pinned-outer').addClass('header-is-down');

    var $el = $(".grid__item.product__media-wrapper");
    var $trigger = $(".pp_opt_color_options_1");
    var $section = $(".grid.product-single");
    var $addons = $(".product-single__add-ons");

    var stickyReady = false;
    var stickyEnabled = false;
    var stickyState = false;
    var ticking = false;


    const height = document.querySelector("header").offsetHeight;

    if ($('.table-of-content-mobile').length) {
      $('.table-of-content-mobile').css('top', height + 4);
    }

    setTimeout(function () {
      if ($el.length && $trigger.length && $section.length) {
        stickyEnabled = true;
        $el.data("initialHeight", $el.outerHeight() * 1.2);
      }
      stickyReady = true;
    }, 3000);

    function onScroll() {
      var y = window.scrollY;

      if (y >= 50) {
        var down = window._tocScrolling ? window._tocScrollDown : y > lastScroll;
        var st = y - 50;

         if ($('.article-content').length) {
          var $articleSection = $('.article-content');
          var scrollTop = $(window).scrollTop();
          var windowHeight = $(window).height();
          var sectionTop = $articleSection.offset().top;
          var sectionHeight = $articleSection.outerHeight();
          var totalScrollable = sectionHeight - windowHeight;
          var scrolled = scrollTop - sectionTop;
          var percent = (scrolled / totalScrollable) * 100;
          percent = Math.max(0, Math.min(100, percent));
          $('.article-scroll-bar').css('width', percent + '%');

          var currentSectionId = null;
          var scrollDirection;
          if (y > lastScroll) {
              scrollDirection = 'down';
          } else if (y < lastScroll) {
              scrollDirection = 'up';
          } else {
              scrollDirection = 'none';
          }
          var headerHeight = $('.header').height();
          let tocMobileHeight = $('.table-of-content-mobile').height();
          let offset = (scrollDirection === 'down')
              ? (window.innerWidth < 990 ? tocMobileHeight + 40 : 40)
              : (window.innerWidth < 990 ? tocMobileHeight + 40 : 40) + headerHeight;
          var scrollPosition = $(window).scrollTop() + offset;
          $('.article-content-main > div[id]').each(function () {
              var elementTop = $(this).offset().top;
              if (scrollPosition >= elementTop) {
                  currentSectionId = $(this).attr('id');
              }
          });
          if (currentSectionId) {
              $('.table-of-content__item').removeClass('active');
              $('.table-of-content__link[data-link="' + currentSectionId + '"]').closest('li').addClass('active');
          }
          var articleImageTop = $('.article__image').offset().top - tocMobileHeight;
          var footerTop = sectionTop + sectionHeight - 60;
          if(y >= articleImageTop && y <= footerTop){
              $('.table-of-content-mobile').removeClass('hide');
              $('.article-scroll-bar-track').show();
          } else {
              $('.table-of-content-mobile').addClass('hide');
              $('.article-scroll-bar-track').hide();
          }
         }

        if (down) {
          $header.addClass("nav-up").removeClass("nav-down");
          $('.compare_three-desks-pinned-outer').removeClass('header-is-down');
          $filterMobile.removeClass("fixed");
          $allProductsHead.removeClass("fixed");
          $(".drop-down-overlay")
            .stop(true, true)
            .fadeOut(200)
            .removeClass("showing");
          $compareMobile.removeClass("nav-showed");
          $compareDesktop.removeClass("nav-showed");
          $standingContent.removeClass("nav-showed");
          $anchorParent.removeClass("anchor-showed");
          $mediaGroup.removeClass("menuVisible");

          if ($header.hasClass("transparent-on-top")) {
            $header.toggleClass("dark-bg", st > $header.height());
          }

          $('.compare_three-desks-pinned-outer').removeClass('header-is-down');
          if ($('.table-of-content').length) {
            $('.table-of-content').css('top', '19px')
          }

          if ($('.table-of-content-mobile').length) {
            $('.table-of-content-mobile').css('top', '4px')
          }

        } else {
          $header.removeClass("nav-up").addClass("nav-down");
          $filterMobile.addClass("fixed");
          $allProductsHead.addClass("fixed");
          $header.addClass("dark-bg");
          $compareMobile.addClass("nav-showed");
          $compareDesktop.addClass("nav-showed");
          $standingContent.addClass("nav-showed");
          $anchorParent.addClass("anchor-showed");
          $mediaGroup.addClass("menuVisible");

          if ($header.hasClass("transparent-on-top")) {
            $header.toggleClass("dark-bg", st > $header.height());
          }
          $('.compare_three-desks-pinned-outer').addClass('header-is-down');

           const height = document.querySelector("header").offsetHeight;
          if ($('.table-of-content').length) {
             $('.table-of-content').css('top',  height + 19)
          }

          if ($('.table-of-content-mobile').length) {
            $('.table-of-content-mobile').css('top', height + 4);
          }
        }
        
      }

      lastScroll = y;

      if (!stickyReady || !stickyEnabled) return;

      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          var vh = window.innerHeight;

          var triggerTop = $trigger[0].getBoundingClientRect().top;
          var triggerReached = triggerTop <= vh - 150;

          var mid = vh / 2 + 100;

          var addonsTop = $addons.length
            ? $addons[0].getBoundingClientRect().top
            : null;
          var addonsReached = addonsTop !== null && addonsTop <= mid;

          var $acc = $(
            ".product__accordion.js--accordion--box:visible"
          ).first();
          var accTop = $acc.length ? $acc[0].getBoundingClientRect().top : null;
          var accReached =
            addonsTop === null && accTop !== null && accTop <= mid;

          var sectionBottom = $section[0].getBoundingClientRect().bottom;
          var pastSection = sectionBottom <= 200;

          var headerDown = $header.hasClass("nav-down");
          $section.toggleClass("below-sticking", headerDown);

          var shouldStick =
            triggerReached && !addonsReached && !accReached && !pastSection;

          if (shouldStick !== stickyState) {
            stickyState = shouldStick;
            $section.toggleClass("is-sticking", shouldStick);
            $el.toggleClass("is-sticking", shouldStick);
          }

          ticking = false;
        });
      }
    }

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);
    onScroll();
  }

  initHeaderAndSticky();

  $(".product__accordion-title").click(function () {
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-wrapper")
      .toggleClass("open");
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-triger")
      .toggleClass("active");
    $(".wrapper-in .add--one--modal").toggleClass("popup_positioned_top");
  });

  $(".product__accordion-triger").click(function () {
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-wrapper")
      .toggleClass("open");
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-triger")
      .toggleClass("active");
    $(".wrapper-in .add--one--modal").toggleClass("popup_positioned_top");
  });

  $(".pp_footer_show_more").click(function () {
    $(".pp_footer_shorter_cont").hide();
    $(".pp_footer_longer_cont").show();
  });

  $(".pp_footer_show_less").click(function () {
    $(".pp_footer_shorter_cont").show();
    $(".pp_footer_longer_cont").hide();
  });

  function stopAllGalleryVideos() {
    window.pdpSwiper.slideTo(0);
    $(".product-single__media")
      .find("video")
      .each(function () {
        this.pause();
        this.currentTime = 0;
      });
  }

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      if ($(".add--one--modal").hasClass("open")) {
        $(".add--one--modal__close").trigger("click");
      }
      $("body").removeClass("popup-open");
      $(".pop-up.active video").each(function () {
        this.pause();
      });
      $(".pop-up").removeClass("active");
      $(".desk_popup_outer").hide();
      $("body").removeClass("no-scroll");

      $(".media--modal__images")
        .find("video")
        .each(function () {
          this.pause();
          this.currentTime = 0;
        });

      closeInfluPopup();
    }
  });

  $(".anchor-menu__item a").on("click", function (event) {
    if ($(window).width() < 960) {
      event.preventDefault();
      var $parentItem = $(this).parent();

      // Get the dimensions of the container and the clicked item
      var $menu = $(".anchor-menu");
      var containerWidth = $menu.outerWidth();
      var itemWidth = $parentItem.outerWidth();

      // Calculate the center position
      var itemOffsetLeft = $parentItem.position().left;
      var scrollPosition =
        $menu.scrollLeft() +
        itemOffsetLeft -
        containerWidth / 2 +
        itemWidth / 2;

      // Animate the scroll to the calculated position
      $menu.animate({ scrollLeft: scrollPosition }, 300);
    }
  });

  $(".desk_popup_outer").click(function (e) {
    if (
      !$(e.target).closest(
        ".desk_popup_inner, .desk_popup_next_btn, .desk_popup_prev_btn"
      ).length
    ) {
      $("body").removeClass("popup-open");
      $(".desk_popup_outer").hide();
    }
  });

  $(".pop-up__wrapper").click(function (e) {
    if (
      !$(e.target).closest(
        ".pop-up__content, .pop-up-inspired__buttons-wrapper"
      ).length
    ) {
      $("body").removeClass("popup-open");
      $(".desk_popup_outer").hide();
      $(".pop-up").removeClass("active");
      $("body").removeClass("no-scroll");
      $(e.target)
        .find("video")
        .each(function () {
          this.pause();
        });
    }
  });

  $(document).on("click", ".tabletops-banner__button", function () {
    $("body").addClass("popup-open");
    $(".desk_popup_outer").css("display", "flex");
    var currentData = $(this).attr("data-index");
    console.log(currentData);
    $(".desk_popup_inner_sw").slick("slickGoTo", currentData);
  });

  $(document).on("click", ".textures__close", function () {
    $("body").removeClass("popup-open");
    $(".desk_popup_outer").hide();
    var currentData = $(this).attr("data-index");
    console.log(currentData);
  });

  // Popup carousel
  $(".desk_popup_inner_sw").slick({
    dots: true,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev pull-left"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect y="-3.8147e-06" width="56" height="56" rx="28" fill="#EFEEE9" /> <path d="M25.1992 19.5945L34.2992 28.6945L25.1992 37.7945" stroke="#19191C" /> </svg></button>',
    nextArrow:
      '<button type="button" class="slick-next pull-left"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect y="-3.8147e-06" width="56" height="56" rx="28" fill="#EFEEE9" /> <path d="M25.1992 19.5945L34.2992 28.6945L25.1992 37.7945" stroke="#19191C" /> </svg></button>',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".desk_popup_next_btn").click(function () {
    $(".desk_popup_inner_sw").find(".slick-next").trigger("click");
  });

  $(".desk_popup_prev_btn").click(function () {
    $(".desk_popup_inner_sw").find(".slick-prev").trigger("click");
  });

  // Popups out of stock functionality
  $(document).on("click", ".modal--variant__label", function () {
    var innerInput = $(this).find("input");
    if (innerInput.is(":disabled")) {
    } else {
      $(".modal--variant__label").removeClass("activelabel");
      $(this).addClass("activelabel");

      var currentVariant = $(this).attr("data-value-handle");
      var currentColor = $(".modal--color__label.activelabel")
        .find("span")
        .attr("data-color-handle");

      var fullTitle = currentColor + "-" + currentVariant;

      var productId = $(".add--one--modal__content").attr("data-product-id");

      var currentVariantId = "";

      $(".pa_label_variant__js").each(function () {
        if ($(this).attr("data-product-id") == productId) {
          if ($(this).attr("data-title") == fullTitle) {
            currentVariantId = $(this).attr("data-id");
          }
        }
      });

      checkAvailableColors();

      setTimeout(function () {
        $(".desktronic_loader3d_out").removeClass("active");
      }, 100);
    }
  });

  $(document).on("click", ".modal--color__label", function () {

    console.log('GOT THE CLICK');
    window.clickedFromPopup = true;
    const innerInput = $(this).find("input");
    if (innerInput.is(":disabled")) return;

    $(".modal--color__label").removeClass("activelabel");
    $(this).addClass("activelabel");

    const currentVariant = $(".modal--variant__label.activelabel").attr(
      "data-value-handle"
    );
    const currentColor = $(this).find("span").attr("data-color-handle");
    const fullTitle = currentColor + "-" + currentVariant;

    const productId = $(".add--one--modal__content").attr("data-product-id");
    let currentVariantId = "";


    var uniqueId = $(this).attr('data-unique-id');
    window.clickedFromPopupColor = true;
    setTimeout(function(){
      window.clickedFromPopupColor = false;
    },500);
    
    $('.add-one_color_option[data-product-id="'+productId+'"]').find('.addone_color-option-out[data-unique-id="'+uniqueId+'"]').trigger('click');


    $(".pa_label_variant__js").each(function () {
      if (
        $(this).attr("data-product-id") == productId &&
        $(this).attr("data-title") == fullTitle
      ) {
        currentVariantId = $(this).attr("data-id");
      }
    });

    const currentParentId = parseFloat(
      $(".add--one--modal__content").attr("data-parent-id")
    );

    if (currentParentId > 0) {
      console.log(currentParentId, "TESTING");
      $(`.add-one-crossell__main[data-id="${currentParentId}"]`)
        .closest(".add-one-crossell")
        .find(
          `.product-single__add-one[data-id="${productId}"] .addonSwatcher_card`
        )
        .each(function () {
          if (
            $(this).find(".swatch-color-ball").attr("data-color-handle") ==
            currentColor
          ) {
            $(".product-single__add-ons").attr("data-from-popup", "1");
            $(this).trigger("click");
            setTimeout(
              () => $(".product-single__add-ons").attr("data-from-popup", "0"),
              1000
            );
          }
        });
    } else {
      $(
        `.product-single__add-one[data-id="${productId}"] .addonSwatcher_card`
      ).each(function () {
        if (
          $(this).find(".swatch-color-ball").attr("data-color-handle") ==
          currentColor
        ) {
          $(".product-single__add-ons").attr("data-from-popup", "1");
          $(this).trigger("click");
          setTimeout(
            () => $(".product-single__add-ons").attr("data-from-popup", "0"),
            1000
          );
        }
      });
    }

    checkAvailableSizes();

    setTimeout(function () {
      $(".desktronic_loader3d_out").removeClass("active");
    }, 100);

   
  });

  function checkAvailableSizes() {
    var currentVariantId;
    var productId = $(".add--one--modal__content").attr("data-product-id");
    var currentColor = $(".modal--color__label.activelabel")
      .find("span")
      .attr("data-color-handle");
    $(".modal--variant__label").each(function () {
      var currentSize = $(this).attr("data-value-handle");
      var fullTitleNew = currentColor + "-" + currentSize;
      var checkingLabel = $(this);
      // console.log(fullTitleNew, 'FULL TITLE');
      $(".pa_label_variant__js").each(function () {
        if ($(this).attr("data-product-id") == productId) {
          if ($(this).attr("data-title") == fullTitleNew) {
            currentVariantId = $(this).attr("data-id");
            var stock = $(this).attr("data-stock");
            if (stock == "1") {
              checkingLabel.removeClass("addone-switcher-label-out");
              checkingLabel.find("input").prop("disabled", false);
            } else {
              checkingLabel.addClass("addone-switcher-label-out");
              checkingLabel.find("input").prop("disabled", true);
            }
            // console.log('Sizes checked', currentVariantId, '===', stock);
          }
        }
      });
    });
  }

  function checkAvailableColors() {
    var currentVariantId;
    var productId = $(".add--one--modal__content").attr("data-product-id");
    var currentSize = $(".modal--variant__label.activelabel").attr(
      "data-value-handle"
    );
    $(".modal--color__label").each(function () {
      var currentColor = $(this).find("span").attr("data-color-handle");
      var fullTitleNew = currentColor + "-" + currentSize;
      var checkingLabel = $(this);
      console.log(fullTitleNew, "FULL TITLE");
      $(".pa_label_variant__js").each(function () {
        if ($(this).attr("data-product-id") == productId) {
          if ($(this).attr("data-title") == fullTitleNew) {
            currentVariantId = $(this).attr("data-id");
            var stock = $(this).attr("data-stock");
            if (stock == "1") {
              checkingLabel.removeClass("addone-color-label-out");
              checkingLabel.find("input").prop("disabled", false);
            } else {
              checkingLabel.addClass("addone-color-label-out");
              checkingLabel.find("input").prop("disabled", true);
            }
            console.log("Colors checked", currentVariantId, "===", stock);
          }
        }
      });
    });
  }

  $(document).on(
  "click",
  ".add--one--modal__handler--box",
  function (event) {

    // 👉 catch the REAL clicked element
    const $target = $(event.target);

    // 🚫 If click happened inside disabled color label → do nothing
    if ($target.closest(".modal--color__label.addone-color-label-out").length) {
      return;
    }

    // ---- existing logic stays exactly the same ----
    const $clickedElement = $(this);
    const $checkbox = $clickedElement.find('input[type="checkbox"]');

    var dataId = $checkbox.attr("data-id");
    const dataProductId = $(".add--one--modal__content").attr(
      "data-product-id"
    );

    var currentId = "";
    if (
      $(".add--one--modal__handler--box").is(":empty") ||
      $(".add--one--modal__handler--box")
        .find(".addone_item-switch")
        .hasClass("active")
    ) {
      var id = $(".add--one--modal__handler--box[is-addone-modal-colors]")
        .find(".modal--color__label.activelabel")
        .find("span")
        .attr("data-variant-id");

      $(".addOneVariantSelection").removeClass("activeVariant");
      $(".addOneVariantSelection").each(function () {
        if ($(this).attr("data-id") == id) {
          $(this).addClass("activeVariant");
        }
      });
      currentId = id;
    } else {
      var color = $(".add--one--modal__handler--box[is-addone-modal-colors]")
        .find(".modal--color__label.activelabel")
        .find("span")
        .attr("data-color-handle");
      var size = $(".add--one--modal__handler--box[is-addone-modal-variants]")
        .find(".modal--variant__label.activelabel")
        .attr("data-value-handle");

      var fullTitle = color + "-" + size;

      $(".addOneVariantSelection").removeClass("activeVariant");
      $(".addOneVariantSelection").each(function () {
        if ($(this).attr("data-variant-title") == fullTitle) {
          $(this).addClass("activeVariant");
          currentId = $(this).attr("data-id");
        }
      });

      $(
        ".add--one--modal__handler--label input[is-addone-modal-checkbox]"
      ).attr("data-id", currentId);
    }

    var variantImageSource = $(".addOneVariantSelection.activeVariant").attr(
      "data-src"
    );

    if (currentId && window.renderAddOneGallery && window.addOneModalRefs) {
      window.renderAddOneGallery(
        dataProductId,
        currentId,
        window.addOneModalRefs,
        ""
      );
      $(".add-one_media_loader").css("display", "flex").addClass("activated");
      $(".add--one--modal__handler--label").addClass("loading");

      setTimeout(() => $(".add-one_media_loader").removeClass("activated"), 900);
      setTimeout(() => $(".add--one--modal__handler--label").removeClass("loading"), 2000);
      setTimeout(() => $(".add-one_media_loader").hide(), 1500);
    } else {
      console.warn(
        "Gallery renderer not ready or missing variant ID:",
        currentId
      );
    }

    $(".variantImage__js-addone").attr("src", variantImageSource);
    $("[is-addone-modal-checkbox]").attr("data-id", currentId);
  }
);

function scrollModalColorsToActive($box) {
  const $slider = $box.find(".modal--color__wrapper");
  if (!$slider.length) return;

  const $active =
    $slider.find(".modal--color__label.activelabel").first().length
      ? $slider.find(".modal--color__label.activelabel").first()
      : $slider
          .find(".modal--color__label input:checked")
          .closest(".modal--color__label")
          .first();

  if (!$active.length) return;
  const sliderEl = $slider[0];
  const activeEl = $active[0];
  const target = activeEl.offsetLeft - sliderEl.clientWidth / 2 + activeEl.offsetWidth / 2;
  const max = sliderEl.scrollWidth - sliderEl.clientWidth;
  const clamped = Math.max(0, Math.min(target, max));
  $slider.stop(true).animate({ scrollLeft: clamped }, 0);
}

function updateModelSliderArrows($box) {
  const $slider = $box.find(".modal--color__wrapper");
  const $prev = $box.find(".modal--color__arrow--prev");
  const $next = $box.find(".modal--color__arrow--next");

  if (!$slider.length) return;

  const el = $slider[0];
  const maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
  const scrollLeft = el.scrollLeft;
  const EDGE = 2;
  if (maxScroll <= EDGE) {
    $prev.addClass("disableArrow");
    $next.addClass("disableArrow");
    return;
  }

  $prev.toggleClass("disableArrow", scrollLeft <= EDGE);
  $next.toggleClass("disableArrow", scrollLeft >= maxScroll - EDGE);
}

function renderModalColors(html, opts = {}) {
  const $box = $('.add--one--modal__handler--box[is-addone-modal-colors]');
  const colorsCount = opts.colorsCount ?? $(html).filter(".modal--color__label").length;
  const variantsCount =
    opts.variantsCount ??
    $('.add--one--modal__handler--box[is-addone-modal-variants] .modal--variant__label').length;

  const doubleSwitchCount =
    opts.doubleSwitchCount ??
    $('.add--one--modal__handler--box[is-addone-modal-variants] .addone_item-switch').length;

  const hasManyColors =
    (opts.hasManyColors !== undefined)
      ? opts.hasManyColors
      : (colorsCount > 5 && (variantsCount > 1 || doubleSwitchCount >= 1));

  $box.empty();

  if (hasManyColors) {
    const $wrapper = $('<div class="modal--color__wrapper"></div>').appendTo($box);
    $wrapper.html(html);

    $box.append(`
      <span class="modal--color__arrow modal--color__arrow--prev">
        <img loading="lazy" src="https://sfycdn.speedsize.com/df738009-02a8-488b-bc12-341d7f8bc071/cdn.shopify.com/s/files/1/0511/8961/2733/files/Vector_83.png?v=1763462513">
      </span>
      <span class="modal--color__arrow modal--color__arrow--next">
        <img loading="lazy" src="https://sfycdn.speedsize.com/df738009-02a8-488b-bc12-341d7f8bc071/cdn.shopify.com/s/files/1/0511/8961/2733/files/Vector_82.png?v=1763462513">
      </span>
    `);
  } else {
    $box.html(html);
  }
 
  requestAnimationFrame(() => {
    const $scope = $('.add--one--modal__handler--box[is-addone-modal-colors]');
    scrollModalColorsToActive($scope);
    updateModelSliderArrows($scope);
  });
}


$(document).off("click.modalColorArrows").on("click.modalColorArrows", ".modal--color__arrow", function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $box = $(this).closest('[is-addone-modal-colors]');
  const $slider = $box.find(".modal--color__wrapper");
  if (!$slider.length) return;

  const step = 120;
  const isPrev = $(this).hasClass("modal--color__arrow--prev");
  const current = $slider.scrollLeft();

  $slider.stop(true).animate({ scrollLeft: current + (isPrev ? -step : step) }, 200);
  setTimeout(() => updateModelSliderArrows($box), 220);
});

$(document).off("scroll.modalColorWrapper").on("scroll.modalColorWrapper", "[is-addone-modal-colors] .modal--color__wrapper", function () {
  const $box = $(this).closest('[is-addone-modal-colors]');
  updateModelSliderArrows($box);
});

window.calculateTabs = function (productId, variantId) {
  $(".pp_addon_poppup_accordion_container").hide();
  $('.pp_addon_poppup_accordion_container[data-id="' + productId + '"]').show();

  const $product = $('.product-single__add-one[data-id="' + productId + '"]');
  const activeType = $product.find('.addone_item-switch.active').attr('data'); 

  const variantsCount =
    $('.add--one--modal__handler--box[is-addone-modal-variants] .modal--variant__label').length;
  const doubleSwitchCount =
    $('.add--one--modal__handler--box[is-addone-modal-variants] .addone_item-switch').length;

  if (activeType === "org") {
    let html = "";

    $product
      .find('.add-one__item.color .add-one__options input[type="radio"]')
      .each(function () {
        const $radio = $(this);
        const radioId = $radio.attr("id");

        const $label = $(`label[for="${CSS.escape(radioId)}"]`);
        if (!$label.length) return;

        const $ball = $label.find(".swatch-color-ball").first();

        const colorHandle = $ball.attr("data-color-handle");
        const vId = $ball.attr("data-variant-id");
        const style = $ball.attr("style") || "";
        const svg = $ball.find("svg").prop("outerHTML") || "";
        const colorName = $label
          .find(".product__variant-label-text_tooltip")
          .first()
          .text();

        const isChecked = $radio.is(":checked");
        const isDisabled =
          $radio.attr("available") === "false" ||
          $label.hasClass("addone-color-label-out") ||
          $label.closest(".addone-color-label-out").length;

        html += `
          <label class="modal--color__label ${isChecked ? "activelabel" : ""} ${isDisabled ? "addone-color-label-out" : ""}">
            <input type="radio" name="modal--color" ${isChecked ? "checked" : ""} ${isDisabled ? "disabled" : ""}>
            <span class="swatch-color-ball"
                  data-variant-id="${vId}"
                  data-color-handle="${colorHandle}"
                  style="${style}">
              ${svg}
            </span>
            <span class="product__variant-label-text_tooltip">${colorName}</span>
          </label>
        `;
      });

    const colorsCount = (html.match(/modal--color__label/g) || []).length;
    renderModalColors(html, { colorsCount, variantsCount, doubleSwitchCount });
    return;
  }

  if (activeType === "second") {
    let html = "";
    const $proOptions = $product.find(".addone_color-option-out");

    $proOptions.each(function () {
      const $option = $(this);

      const $ball = $option.find(".swatch-color-ball").first();
      const colorHandle = $ball.attr("data-color-handle");
      const vId = $ball.attr("data-variant-id");
      const style = $ball.attr("style") || "";
      const svg = $ball.find("svg").prop("outerHTML") || "";
      const colorName = $option
        .find(".product__variant-label-text_tooltip")
        .first()
        .text();

      const uniqueID = $option.attr("data-unique-id");
      const isActive = $option.hasClass("active");
      const isDisabled = $option.hasClass("addone-color-label-out");

      html += `
        <label class="modal--color__label ${isActive ? "activelabel" : ""} ${isDisabled ? "addone-color-label-out" : ""}"
               data-unique-id="${uniqueID}">
          <input type="radio" name="modal--color" ${isActive ? "checked" : ""} ${isDisabled ? "disabled" : ""}>
          <span class="swatch-color-ball"
                data-variant-id="${vId}"
                data-color-handle="${colorHandle}"
                style="${style}">
            ${svg}
          </span>
          <span class="product__variant-label-text_tooltip">${colorName}</span>
        </label>
      `;
    });

    const colorsCount = $proOptions.length;

    renderModalColors(html, { colorsCount, variantsCount, doubleSwitchCount });
    return;
  }
};

  $(document).on("click", ".add-one__popup-opener", function () {
    $(".add-one_media_loader").css("display", "flex");
    $(".add-one_media_loader").addClass("activated");
    const $clickedElement = $(this).closest(".product-single__add-one");
    const $checkbox = $clickedElement.find('input[type="checkbox"]');
    var dataId = $checkbox.attr("data-id");
    var dataProductId = $(this).attr("data-product-id");

    $(".add--one--modal__content").attr("data-parent-id", "");

    var dataParentId = $(this)
      .closest(".add-one-crossell")
      .find(".add-one-crossell__main")
      .attr("data-id");

    $(".add--one--modal__content").attr("data-parent-id", dataParentId);

    $(".pp_addon_poppup_accordion_container").hide();
    $(
      '.pp_addon_poppup_accordion_container[data-id="' + dataProductId + '"]'
    ).show();

    console.log(dataProductId, "DATA PRODUCT ID OPENED");

    $(".addOneVariantSelection").removeClass("activeVariant");
    $(".addOneVariantSelection").each(function () {
      if ($(this).attr("data-id") == dataId) {
        $(this).addClass("activeVariant");
      }
    });

    var variantImageSource = $(".addOneVariantSelection.activeVariant").attr(
      "data-src"
    );

    $(".variantImage__js-addone").attr("src", variantImageSource);

    $("[is-addone-modal-checkbox]").attr("data-id", dataId);

    $(".modal--color__label").find("input[checked]").trigger("click");
  });

  $(document).on(
    "click",
    ".add--one--modal__image--list .video_container__popup",
    function () {
      var video = $(this).find("video").get(0);
      if (video) {
        if (video.paused) {
          video.play();
          $(this).find(".video_container__play-icon").hide();
        } else {
          video.pause();
          $(this).find(".video_container__play-icon").show();
        }
      }
    }
  );

  $(
    ".product .product-single__add-one .add-one__item fieldset .swatch-color-label.disabled"
  ).on("click mousedown mouseup keydown keyup", function (event) {
    event.preventDefault();
    event.stopPropagation();
  });

  $(
    ".product .product-single__add-one .add-one__item fieldset .swatch-color-label.disabled span"
  ).on("click mousedown mouseup keydown keyup", function (event) {
    event.preventDefault();
    event.stopPropagation();
  });

  function addDisablingToSwitcherInput() {
    $("label.addone-switcher-label-out").each(function () {
      var associatedInput = $(this).prev("input");
      if (associatedInput.length > 0) {
        associatedInput.prop("disabled", true);
      }
    });
  }

  window.clickedFromPopup = false;

  $(document).on("click", ".add--one--modal__handler--box", function (evt) {
    window.clickedFromPopup = true;
    setTimeout(function () {
      window.clickedFromPopup = false;
    }, 500);
  });

  $(document).on(
    "click",
    ".product-single__add-one .addonSwatcher_card",
    function (e) {
      if ($(".product_selection-all-box").hasClass("preloadNone")) {
        // Out of stock
      } else {
        console.log(window.clickedFromPopup, "CLICKED FROM POPUP");

        // if (window.clickedFromPopup == true) {
        //   return;
        // }

        if ($(this).hasClass("addone-color-label-out")) {
        } else {
          if (window.mmqShowed == true) {
            $(".product-3d-window").addClass("open");
            $('.product__media-zoomin-btns').addClass('activated');
          } else {
            $(".desktronic_loader3d_out").addClass("active");
            $(".loader.desktronic_loader_2step").show();

            const mmqInterval = setInterval(async () => {
              if (window.mmqLoaded) {
                console.log("mmq loaded 441");
                clearInterval(mmqInterval);
                $(".desktronic_loader3d_out").addClass("active2nd");
                $(".loader.desktronic_loader_2step").hide();
                $(".loader.desktronic_loader_3step").show();

                $(".product-3d-window").addClass("open");
                $('.product__media-zoomin-btns').addClass('activated');

                setTimeout(function () {
                  $(".loader.desktronic_loader_2step").hide();
                  $(".loader.desktronic_loader_3step").hide();
                  $(".desktronic_loader3d_out").removeClass("active2nd");
                  $(".desktronic_loader3d_out").removeClass("active");
                }, 3500);

                window.mmqShowed = true;
              }
            }, 200);
          }

          window.setPreload();

          if ($(".product-3d-window").hasClass("open")) {
            setTimeout(function () {
              window.removePreloads();
              mmqLoadedDetectedAt = true;
            }, 2000);
          } else {
            var checkOpen = setInterval(function () {
              if ($(".product-3d-window").hasClass("open")) {
                clearInterval(checkOpen); // stop checking
              }
            }, 100);
          }
        }

        var swatchVariantId = $(this).find(".swatch-color-ball").attr("data-variant-id");
        var $productContainer = $(this).closest(".product-single__add-one");

        if (swatchVariantId) {
          $productContainer.find(".addOneMainInput__js").attr("data-id", swatchVariantId);
        }

        var capturedVariantId = swatchVariantId;

        setTimeout(function () {
          var currentId = capturedVariantId || $productContainer.find(".addOneMainInput__js").attr("data-id");
          var currentImg = $(
            '.pa_label_variant__js[data-id="' + currentId + '"]'
          ).attr("data-src");

          var currentExtraDiscount = $(
            '.pa_label_variant__js[data-id="' + currentId + '"]'
          ).attr("data-extra-discount");

          $productContainer
            .find(".add-one__image")
            .find("img")
            .attr("src", currentImg);

          $productContainer.find('.add-one__free-badge').html(currentExtraDiscount);

          $productContainer
            .find(".add-one__prices-current")
            .attr("data-variant-id", currentId);

          $productContainer
            .find(".add-one__prices-compare-at__money")
            .attr("data-variant-id", currentId);

          $productContainer
            .find(".add-one__discount")
            .attr("data-variant-id", currentId);

          var $chairsCfg = $('.config_upsell-chairs__js[data-id="' + currentId + '"]');
          var $labelCfg = $('.pa_label_variant__js[data-id="' + currentId + '"]');

          var currentPrice = $chairsCfg.attr("data-price") || $labelCfg.attr("data-price");
          var currentComparePrice = $chairsCfg.attr("data-compare-price") || $labelCfg.attr("data-compare-price");
          var currentCompareFinalPrice = $chairsCfg.attr("data-compare-final-price");
          var currentDiscount = $chairsCfg.attr('data-addone-discount');

          if (currentPrice) {
            $productContainer
              .find(".add-one__discount")
              .html(currentDiscount);
            $productContainer
              .find(".add-one__prices-current")
              .html(currentPrice);
            $productContainer
              .find(".add-one__prices-compare-at__money:not(.final-compare-at)")
              .html(currentComparePrice || '');
            var $finalCompareAt = $productContainer.find(".add-one__prices-compare-at__money.final-compare-at");
            var hasCompareFinalPrice = currentCompareFinalPrice && /[1-9]/.test(currentCompareFinalPrice);
            if (hasCompareFinalPrice) {
              if ($finalCompareAt.length) {
                $finalCompareAt.html(currentCompareFinalPrice);
              } else {
                $productContainer
                  .find(".add-one__prices-compare-at__money:not(.final-compare-at)")
                  .last()
                  .after('<span class="add-one__prices-compare-at__money final-compare-at" data-variant-id="' + currentId + '">' + currentCompareFinalPrice + '</span>');
              }
            } else {
              $finalCompareAt.remove();
            }
          }
        }, 200);

        stopAllGalleryVideos();
      }
    }
  );

  // $('.product-3d-window').addClass('open');

  $(".addOneMainInput__js").change(function () {
    console.log(window.clickedFromPopup, "CLICKED FROM POPUP changed");

    window.calculateAddons();
    if (window.clickedFromPopup == true) {
      return;
    }

    if (window.mmqShowed == true) {
      $(".product-3d-window").addClass("open");
      $('.product__media-zoomin-btns').addClass('activated');
    } else {
      $(".desktronic_loader3d_out").addClass("active");
      $(".loader.desktronic_loader_2step").show();

      const mmqInterval = setInterval(async () => {
        if (window.mmqLoaded) {
          console.log("mmq loaded 504");
          clearInterval(mmqInterval);
          $(".desktronic_loader3d_out").addClass("active2nd");
          $(".loader.desktronic_loader_2step").hide();
          $(".loader.desktronic_loader_3step").show();
          $(".product-3d-window").addClass("open");
          $('.product__media-zoomin-btns').addClass('activated');

          setTimeout(function () {
            $(".loader.desktronic_loader_2step").hide();
            $(".loader.desktronic_loader_3step").hide();
            $(".desktronic_loader3d_out").removeClass("active2nd");
            $(".desktronic_loader3d_out").removeClass("active");
          }, 3500);

          window.mmqShowed = true;
        }
      }, 200);
    }

    if ($(".product_selection-all-box").hasClass("preloadNone")) {
    } else {
      window.setPreload();
    }

    if ($(".product-3d-window").hasClass("open")) {
      setTimeout(function () {
        window.removePreloads();
        mmqLoadedDetectedAt = true;
      }, 2000);
    } else {
      var checkOpen = setInterval(function () {
        if ($(".product-3d-window").hasClass("open")) {
          clearInterval(checkOpen); // stop checking
        }
      }, 100);
    }

    var currentId = $(this).attr("data-id");
    var currentImg = $(
      '.pa_label_variant__js[data-id="' + currentId + '"]'
    ).attr("data-src");
    console.log(currentId, currentImg);
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__image")
      .find("img")
      .attr("src", currentImg);


    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-current")
      .attr("data-id", currentId);
      
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-compare-at__money")
      .attr("data-id", currentId);

    stopAllGalleryVideos();
  });

  $(document).on("click", ".js-qty", function () {
    var currentValue = $(this).find("input").val();
    console.log(currentValue);
    $(".mobile-sticky-atc-btn__wrapper").find(".qty__num").val(currentValue);
  });

  $(document).on("click", ".desktronic_loader3d_out.loader3d", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
  });

  $(document).on("click", ".upsell_cart__button", function () {
    $(this).find(".desk_btn_content").hide();
    $(this).find(".desk_button_loader").show();
    $(this).find(".desk_btn_loader").show();
    $(this).addClass("loading");
  });

  $(document).on("click", "cart-remove-button", function () {
    $(this).addClass("loading");
  });

  $(document).on("click", ".drawer__footer .shipping", function () {
    $(this).addClass("loading");
  });

  $(".single-option-selector__radio").each(function () {
    const target = this;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          const $target = $(target);
          const hasDisabled = $target.hasClass("disabled-label");

          if (hasDisabled) {
            $target
              .closest(".swiper-slide")
              .find(".popular-badge")
              .addClass("hided_popuplar_badge");
          } else {
            $target
              .closest(".swiper-slide")
              .find(".popular-badge")
              .removeClass("hided_popuplar_badge");
          }
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });

  $(".addonTypeSelection").click(function () {
    var currentTitle = $(this).attr("data-value-title");
    // alert(currentTitle);
    var currentValue = $(this)
      .closest(".hasMultiOptions")
      .find(".product__additional-variant")
      .attr("data-option");
    currentValue = String(currentValue).split("/");
    var newValue = currentValue[0] + "/ " + currentTitle;
    var clickedEl = $(this);
    setTimeout(function () {
      clickedEl
        .closest(".hasMultiOptions")
        .find(".product__additional-variant")
        .attr("data-option", newValue);
      clickedEl
        .closest(".hasMultiOptions")
        .find(".product__additional-variant")
        .find("input")
        .each(function () {
          var currentVal = $(this).attr("value");
          currentVal = String(currentVal).split("/");
          var newValue = currentVal[0] + "/ " + currentTitle;
          console.log(currentVal, "CURRENT VAL");
          console.log(newValue, "NEW VAL");
          $(this).attr("value", newValue);
        });
    }, 50);
  });

  $(document).on("click", ".product-single__add-one", function (event) {
    var thisEl = $(this);
    setTimeout(function () {
      var selectedId = thisEl.find(".addOneMainInput__js").attr("data-id");

      var selectedColor = $(
        '.add-one_variant_config[data-id="' + selectedId + '"]'
      ).attr("data-color");

      thisEl.find(".addOneMainInput__js").attr("data-color", selectedColor);

    });
  });

  $(document).on("click", ".product-single__add-ons__wrap", function () {
    window.calculateAddons();
  });

  $(document).on("click", ".product-single_read_more_btn", function () {
    var data = $(this).attr("data");
    if (data == "more") {
      // $('.product-single_read_more__less_part').hide();
      $(".product-single_read_more__full_part").css("display", "inline");
      $('.product-single_read_more_btn[data="less"]').css("display", "block");
      $('.product-single_read_more_btn[data="more"]').hide();
      $(".product-single_read_more_dots").hide();
    } else {
      // $('.product-single_read_more__less_part').show();
      $(".product-single_read_more__full_part").hide();
      $('.product-single_read_more_btn[data="less"]').hide();
      $('.product-single_read_more_btn[data="more"]').show();
      $(".product-single_read_more_dots").css("display", "inline");
    }
  });

  $(document).on("click", " .text_content-toggle", function () {
    var data = $(this).attr("data");
    if (data == "more") {
      $('.text_content-toggle[data="less"]').css("display", "inline");
      $('.text_content-toggle[data="more"]').hide();
      $(".text_content-collection-dots").hide();
      $(".text_content-collection-remaining").css("display", "inline");
    } else {
      $('.text_content-toggle[data="less"]').hide();
      $('.text_content-toggle[data="more"]').css("display", "inline");
      $(".text_content-collection-dots").css("display", "inline");
      $(".text_content-collection-remaining").hide();
    }
  });

  window.calculateAddons = function () {
    setTimeout(function () {
      var productQnt = 1;
      $(".add-one__3d-checked input:checked").each(function () {
        productQnt++;
      });

      // console.log(productQnt, ' quantity');
      if (productQnt > 1) {
        var atcText = $(".js-custom-add-to-cart")
          .attr("data-title-qnt")
          .replace("{}", productQnt);
        $(".desk_btn_content").find("span").html(atcText);
        $(".mobile-sticky-atc-btn__handlers")
          .find(".desk_btn_content")
          .html(atcText);
      } else {
        var atcText = $(".js-custom-add-to-cart").attr("data-title");
        $(".desk_btn_content").find("span").html(atcText);
        $(".mobile-sticky-atc-btn__handlers")
          .find(".desk_btn_content")
          .html(atcText);
      }
    }, 500);
  };



  $(document).on("click", ".js-qty__adjust", function () {
    var $el = $(this);
    var qty = parseInt(
      $(this).closest(".js-qty").find(".js-qty__num").val().replace(/\D/g, "")
    );
    if ($el.hasClass("js-qty__adjust--plus")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 1) qty = 1;
    }
    $(this).closest(".js-qty").find(".js-qty__num").val(qty);
    $(".mobile-sticky-atc-btn__handlers").find(".qty__num").val(qty);
  });

  window.setStockNote = function () {
    setTimeout(function () {
      var currentId = $(".pp_config__main_id-js").attr("data-id");

      $(".oos-limit-reached_box.pdp").addClass("hided");

      var inventoryPolicy = $('.pp_variant_config[data-id="' + currentId + '"]').attr("data-inventory-policy");
      if (inventoryPolicy === "DENY") return;

      var currentStockCount = parseFloat(
        $('.oos-limit-reached_box.pdp[data-id="' + currentId + '"]').attr(
          "data-stock"
        )
      );

      var currentPdpQuantity = parseFloat($(".js-qty__num").val());

      $(".oos-limit-reached_box.pdp").addClass("hided");

      if (currentPdpQuantity >= currentStockCount) {
        $(
          '.oos-limit-reached_box.pdp[data-id="' + currentId + '"]'
        ).removeClass("hided");
      } else {
        $(".oos-limit-reached_box.pdp").addClass("hided");
      }
    }, 50);
  };

  window.removeStockNote = function () {
    $(".oos-limit-reached_box.pdp").addClass("hided");
  };

  // $('.product__additional-variant .crossellProduct').click(function() {

  $(document).on("click", ".crossellProduct", function () {
    $(this)
      .closest(".product__additional-variant")
      .find(".crossellProduct")
      .removeClass("activeLabelInput");
    $(this).addClass("activeLabelInput");
    var forAttr = $(this).attr("for");
    var currentId = $(this).find(".swatch-color-ball").attr("data-variant-id");
    var currentMmqCode = $('input[id="' + forAttr + '"]').attr("data-mmq-code");
    var currentMmqCodeBlock = $('input[id="' + forAttr + '"]').attr(
      "data-mmq-block"
    );

    console.log(currentId, currentMmqCode, "CURRENT ID");

    $(this)
      .closest(".product-single__addone-label")
      .find(".addOneMainInput__js")
      .attr("data-id", currentId);

    $(this)
      .closest(".product-single__addone-label")
      .find(".addOneMainInput__js")
      .attr("data-mmq-code", currentMmqCode);
  });

  function setGalleryArrow() {
    var thumbsHeight = $(
      ".product .swiper-initialized .product-single__thumbnails"
    ).height();
    var mainBoxHeight = $(".product-single__media-group").height();
    if (thumbsHeight < mainBoxHeight) {
      $(".pp_gallery-scroll-down").hide();
    } else {
      $(".pp_gallery-scroll-down").show();
    }
  }

  setGalleryArrow();

  $(window).on("resize", function () {
    setGalleryArrow();
  });

  $(".product-gallery_opener_btn_outer").mouseover(function () {
    $(".opener-3D__tooltip").show();
    setTimeout(function () {
      $(".opener-3D__tooltip").addClass("active");
    }, 100);
  });

  $(".product-gallery_opener_btn_outer").mouseleave(function () {
    $(".opener-3D__tooltip").removeClass("active");
    setTimeout(function () {
      $(".opener-3D__tooltip").hide();
    }, 100);
  });

  var galleryWrapper = $(".product__gallery-wrapper");

  galleryWrapper.on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var scrollHeight = $(this)[0].scrollHeight;
    var wrapperHeight = $(this).innerHeight();

    if (scrollTop > 10) {
      $(".pp_gallery-scroll-up--btn").css("display", "flex");
    } else {
      $(".pp_gallery-scroll-up--btn").hide();
    }

    // Detect if scrolled to bottom
    if (scrollTop + wrapperHeight >= scrollHeight - 1) {
      // -1 for safe rounding
      console.log("Scrolled to the bottom");
      $(".pp_gallery-scroll-down").hide();
    } else {
      $(".pp_gallery-scroll-down").css("display", "flex");
    }
  });

  $(".pp_gallery-scroll-up--btn").click(function () {
    var galleryWrapper = $(".product__gallery-wrapper");
    var currentScroll = galleryWrapper.scrollTop();
    galleryWrapper.scrollTop(currentScroll - 200);
  });

  $(".pp_gallery-scroll-down--btn").click(function () {
    var galleryWrapper = $(".product__gallery-wrapper");
    var currentScroll = galleryWrapper.scrollTop();
    galleryWrapper.scrollTop(currentScroll + 200);
  });

  function setVariant(variantId) {
    var variantSrc = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
      "data-featured-img"
    );
    $("#product-variant__src").attr("src", variantSrc);
    $("#product-variant__thumb").attr("src", variantSrc);
    $(".product_thumb-sticky").attr("src", variantSrc);
  }

  // Specs info
  $(".product_tabletop-nav-btn").click(function () {
    $(this)
      .closest(".product_spec_box-content")
      .find(".product_tabletop-nav-btn")
      .removeClass("active");
    $(this).addClass("active");
    var currentData = $(this).attr("data");
    $(this)
      .closest(".product_spec_box-content")
      .find(".product_spec-size-info")
      .addClass("hided");
    $(this)
      .closest(".product_spec_box-content")
      .find('.product_spec-size-info[data="' + currentData + '"]')
      .removeClass("hided");

    $(this)
      .closest(".product_spec_box-layout")
      .find(".product_spec-size-info")
      .addClass("hided");
    $(this)
      .closest(".product_spec_box-layout")
      .find('.product_spec-size-info[data="' + currentData + '"]')
      .removeClass("hided");
  });

  $(".product_spec-tabletops-switcher-btn").click(function () {
    $(".product_spec-tabletops-switcher-btn").removeClass("active");
    $(this).addClass("active");
    var currentData = $(this).attr("data");
    $(".product_spec_box-layout.product_spec-tabletops").addClass("hided");
    $(
      '.product_spec_box-layout.product_spec-tabletops[data="' +
        currentData +
        '"]'
    ).removeClass("hided");

    $(".product_arm-image-box").addClass("hided");
    $('.product_arm-image-box[data="' + currentData + '"]').removeClass(
      "hided"
    );
  });

  $(".product_specs_box").click(function (e) {
    // if the click happened inside the content area, ignore it
    if ($(e.target).closest(".product_spec-tab-content").length) {
      return;
    }

    const $box = $(this);
    const $content = $box.find(".product_spec-tab-content");

    if ($content.is(":animated")) return; // ignore while animating

    $box.toggleClass("active");
    $content.slideToggle();
  });

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      $(".product-charity-outer_whole").hide();
      $(".product-colors-comparison_outer").hide();
      $(".product-comparison-outer_whole").hide();
      $(".product-price-comparison_outer").hide();
      $(".product-price-outer_whole").hide();
      $("body").removeClass("popup-open");
    }
  });

  $(".product-price-comparison_outer").click(function (e) {
    if (!$(e.target).closest(".product-price-comparison_popup").length) {
      $(".product-price-comparison_outer").hide();
      $(".product-price-outer_whole").hide();
      $("body").removeClass("popup-open");
    }
  });

  $(".product-charity-outer_whole").click(function (e) {
    if (!$(e.target).closest(".product-charity-comparison_popup").length) {
      $(".product-charity-outer_whole").hide();
      $("body").removeClass("popup-open");
    }
  });

  $(".product-comparison-outer_whole").click(function (e) {
    if (!$(e.target).closest(".product-colors-comparison_popup").length) {
      $(".product-comparison-outer_whole").hide();
      $("body").removeClass("popup-open");
    }
  });

  $(".tree-banner__button").click(function (evt) {
    evt.preventDefault();
    $(".product-charity-outer_whole").show();
    $("body").addClass("popup-open");
    $(".product-charity-comparison_outer").css("display", "flex");
    var winHeight = $(window).height();
    if (winHeight > 1000) {
      if ($(window).width() > 678) {
        var popupHeight = $(".product-charity-comparison_popup").outerHeight();
        $(".product-charity-popup_close").css(
          "top",
          "calc(50% - " + popupHeight / 2 + "px + 16px)"
        );
        $(".product-charity-comparison_outer").css("align-items", "center");
      }
    } else {
      $(".product-charity-comparison_outer").css("align-items", "flex-start");
      $(".product-charity-popup_close").css("top", "72px");
    }
  });

  $(".hero-press_cell").click(function () {
    $(".hero-press_title_box").css("opacity", "0");
    $(".hero-press_cell").removeClass("active");
    $(this).addClass("active");
    var currentId = $(this).attr("data-id");
    setTimeout(function () {
      $(".hero-press_title").addClass("hided");
      $('.hero-press_title[data-id="' + currentId + '"]').removeClass("hided");
      $(".hero-press_title_box").css("opacity", "1");
    }, 500);
  });

  $(".hero-press_cell").mouseover(function () {
    $(this).trigger("click");
  });

  $(".hero-press_wrapper").each(function () {
    var $root = $(this);
    var $scroller = $root.find(".hero-press_grid-wrapper");
    var INTERVAL = window.press_logos_interval || 6000;
    var auto = null,
      hovering = false;

    function isMobile() {
      return window.matchMedia("(max-width: 678px)").matches;
    }

    function getCells() {
      return isMobile()
        ? $root.find(".Mobile_only .hero-press_cell")
        : $root.find(".Desktop_only .hero-press_cell");
    }

    function getActive() {
      var $cells = getCells();
      var $active = $cells.filter(".active").first();
      return $active.length ? $active : $cells.first();
    }

    function clampScroll(x) {
      var el = $scroller.get(0);
      var max = Math.max(0, el.scrollWidth - el.clientWidth);
      return Math.max(0, Math.min(x, max));
    }

    function scrollActiveIntoView() {
      if (!isMobile()) return;
      var $active = getActive();
      if (!$active.length) return;

      var el = $scroller.get(0);
      var curr = el.scrollLeft;
      var aRect = $active.get(0).getBoundingClientRect();
      var sRect = el.getBoundingClientRect();
      var delta = aRect.left - sRect.left;
      var centerOffset = sRect.width / 2 - aRect.width / 2;
      var target = clampScroll(curr + delta - centerOffset);

      $scroller.stop().animate({ scrollLeft: target }, 300);
    }

    function stopAuto() {
      if (auto) {
        clearInterval(auto);
        auto = null;
      }
    }
    function startAuto() {
      stopAuto();
      auto = setInterval(goNext, INTERVAL);
    }
    function resetAuto(forceStart) {
      stopAuto();
      if (forceStart || !hovering) startAuto();
    }

    function activate($cell, isManual) {
      var $grid = $cell.closest(".hero-press_grid");
      $grid.find(".hero-press_cell").removeClass("active");
      $cell.addClass("active");

      $(".hero-press_title_box").css("opacity", "0");
      var currentId = $cell.attr("data-id");
      setTimeout(function () {
        $(".hero-press_title").addClass("hided");
        $('.hero-press_title[data-id="' + currentId + '"]').removeClass(
          "hided"
        );
        $(".hero-press_title_box").css("opacity", "1");
      }, 200);

      setTimeout(scrollActiveIntoView, 0);

      if (isManual) {
        // Desktop: respect hover-pause; Mobile: always keep looping (reset timer)
        resetAuto(isMobile());
      }
    }

    function goNext() {
      var $cells = getCells();
      if (!$cells.length) return;

      var total = $cells.length;
      var $active = getActive();
      var currIndex = Number($active.data("index")) || 1;

      var nextIndex = currIndex + 1;

      if (isMobile()) {
        // If we would move onto the very last item, instead jump to #2
        if (nextIndex === total) {
          nextIndex = 2;
        } else if (nextIndex > total) {
          nextIndex = 2; // safety
        }
      } else {
        if (nextIndex > total) nextIndex = 1; // desktop: normal wrap
      }

      var $next = $cells.filter('[data-index="' + nextIndex + '"]').first();
      if ($next.length) activate($next, false);
    }

    $root.on("click", ".hero-press_cell", function (e) {
      activate($(this), !e.isTrigger);
    });

    // Pause on hover ONLY on desktop; on mobile just reset the timer so it keeps looping
    $root.on("mouseenter", function () {
      if (isMobile()) {
        resetAuto(true);
      } else {
        hovering = true;
        stopAuto();
      }
    });
    $root.on("mouseleave", function () {
      if (isMobile()) {
        resetAuto(true);
      } else {
        hovering = false;
        startAuto();
      }
    });
    // Touch interactions on mobile should also just reset the timer
    $root.on("touchstart touchend touchcancel", function () {
      if (isMobile()) resetAuto(true);
    });

    $(window).on("resize", function () {
      scrollActiveIntoView();
      if (isMobile() && !auto) startAuto();
    });

    startAuto();

    // On load: select the 2nd item and center it on mobile
    if (isMobile()) {
      var $second = $root
        .find('.Mobile_only .hero-press_cell[data-index="2"]')
        .first();
      if ($second.length) activate($second, false);
      else setTimeout(scrollActiveIntoView, 0);
    }
  });

  $(".collection_seo_nav-btn-grid_wrapper-outer").each(function () {
    var $outer = $(this),
      $s = $outer.find(".collection_seo_nav-btn-grid_wrapper"),
      $r = $outer.find(".collection-seo_nav_arrow--right"), // arrow IMG (right)
      $l = $outer.find(".collection-seo_nav_arrow--left"), // arrow IMG (left)
      $or = $outer.find(".collection-seo_nav_right-box-overlay"),
      $ol = $outer.find(".collection-seo_nav_left-box-overlay"),
      STEP = 200;

    function max() {
      var el = $s[0];
      return Math.max(0, el.scrollWidth - el.clientWidth);
    }

    function update() {
      var sl = $s.scrollLeft(),
        m = max();
      $l.toggleClass("hided", sl <= 0);
      $ol.toggleClass("hided", sl <= 0);
      $r.toggleClass("hided", sl >= m - 1);
      $or.toggleClass("hided", sl >= m - 1);
    }

    function slide(dx) {
      var target = Math.max(0, Math.min($s.scrollLeft() + dx, max()));
      $s.stop().animate({ scrollLeft: target }, 250, update);
    }

    // Click only on arrow images, and ALSO on the overlays
    $r.add($or).on("click", function (e) {
      e.preventDefault();
      slide(STEP);
    });
    $l.add($ol).on("click", function (e) {
      e.preventDefault();
      slide(-STEP);
    });

    $s.on("scroll", update);
    $(window).on("resize", update);

    update();
  });

  $(".influ-popup_close").click(function () {
    closeInfluPopup();
  });

  $(document).on("click", ".influ-popup_outer", function (e) {
    if (!$(e.target).closest(".influ-popup_inner").length) {
      closeInfluPopup();
    }
  });

  function closeInfluPopup() {
    $(".influ-popup_outer-whole").hide();
    $(".influ-popup_close").hide();
    $("body").removeClass("modal--open");
  }

  $(".certificates_scroll-area-outer").each(function () {
    var $outer = $(this);
    var $area = $outer.find(".certificates_scroll-area");
    var $prev = $outer.find(".certificates_scroll-arrow-prev");
    var $next = $outer.find(".certificates_scroll-arrow-next");
    var step = 300;

    function maxScroll() {
      var el = $area.get(0);
      return Math.max(0, el.scrollWidth - el.clientWidth);
    }

    function updateArrows() {
      var sl = $area.scrollLeft();
      var m = maxScroll();
      if (sl <= 0) $prev.addClass("hided");
      else $prev.removeClass("hided");
      if (sl >= m - 1) $next.addClass("hided");
      else $next.removeClass("hided");
    }

    function scrollBy(dx) {
      var target = Math.max(0, Math.min(maxScroll(), $area.scrollLeft() + dx));
      $area.stop().animate({ scrollLeft: target }, 250, updateArrows);
    }

    $prev.on("click", function (e) {
      e.preventDefault();
      scrollBy(-step);
    });
    $next.on("click", function (e) {
      e.preventDefault();
      scrollBy(step);
    });

    var ticking = false;
    $area.on("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
        ticking = true;
      }
    });

    $(window).on("resize", updateArrows);
    setTimeout(updateArrows, 0);
  });

  // Accessories videos

  function getPopupEls() {
    const $popup = $(".product_accessories-video-popup");
    const $inner = $popup.find(".product_accessories-video-popup-inn");
    const $close = $popup.find(".product_accessories-popup-close");
    const $video = $popup.find(".product_acc-video");
    const video = $video.get(0);
    const $source = $video.find("source");
    return { $popup, $inner, $close, $video, video, $source };
  }

  function openMobileVideo(src) {
    const { $popup, $close, video, $source } = getPopupEls();
    if (!video) return;

    if (src) $source.attr("src", src);
    video.muted = true;
    video.playsInline = true;
    try {
      video.load();
    } catch (_) {}

    $popup.css("display", "flex");

    const p = video.play?.();
    if (p && typeof p.catch === "function") p.catch(() => {});
  }

  function closeMobileVideo() {
    const { $popup, $close, video, $source } = getPopupEls();
    if (!video) return;

    try {
      video.pause();
    } catch (_) {}
    try {
      video.currentTime = 0;
    } catch (_) {}
    $source.attr("src", "");
    try {
      video.load();
    } catch (_) {}

    $popup.hide();
  }

  $(document).on("click", ".product_acc-video-play--btn", function (e) {
    e.stopPropagation();

    if ($(window).width() > 960) {
      $(".product_accessories-video-block")
        .removeClass("active")
        .each(function () {
          const video = $(this).find(".product_acc-video").get(0);
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });

      const block = $(this).closest(".product_accessories-video-block");
      block.addClass("active");

      const video = block.find(".product_acc-video").get(0);
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    } else {
      const $block = $(this).closest(".product_accessories-video-block");
      let src =
        $(this).data("videoSrc") ||
        $block.data("videoSrc") ||
        $block.find(".product_acc-video source").attr("src") ||
        "";
      openMobileVideo(src);
    }

    const $slide = $(this).closest(".swiper-slide");
    if ($slide.length && window.limitedSwiper) {
      window.limitedSwiper.slideTo($slide.index(), 1000);
    }
  });

  $(document).on("click", ".product_acc-video-top--btn", function (e) {
    e.stopPropagation();
    if ($(window).width() > 960) {
      const block = $(this).closest(".product_accessories-video-block");
      block.removeClass("active");

      const video = block.find(".product_acc-video").get(0);
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      window.updateArrows();
    }
  });

  $(document).on("click", ".product_accessories-video-block", function (e) {
    if (
      $(e.target).closest(
        ".product_acc-video-play--btn, .product_acc-video-top--btn"
      ).length
    )
      return;

    if (!$(this).hasClass("active")) {
      $(this).find(".product_acc-video-play--btn").trigger("click");
    }

    if ($(window).width() <= 960) return;

    const wrapper = document.querySelector(".swiper_accessoires_wrapper-outer");
    const block = this;
    if (!wrapper || !block) return;

    setTimeout(() => {
      const scrollLeft =
        block.offsetLeft - wrapper.clientWidth / 2 + block.offsetWidth / 2;
      const max = wrapper.scrollWidth - wrapper.clientWidth;
      wrapper.scrollTo({
        left: Math.max(0, Math.min(scrollLeft, max)),
        behavior: "smooth",
      });
      setTimeout(() => window.updateArrows && window.updateArrows(), 300);
    }, 250);
  });

  $(document).on("click", ".product_accessories-popup-close", function (e) {
    e.stopPropagation();
    closeMobileVideo();
  });

  $(document).on("click", ".product_accessories-video-popup", function (e) {
    if (!$(e.target).closest(".product_accessories-video-popup-inn").length) {
      closeMobileVideo();
    }
  });

  $(document).on(
    "click",
    ".product_accessories-video-block.active .product_acc-video",
    function (e) {
      if ($(window).width() > 768) {
        e.stopPropagation();

        const block = $(this).closest(".product_accessories-video-block");
        block.removeClass("active");

        const video = $(this).get(0);
        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        window.updateArrows();
      }
    }
  );

  document
    .querySelector(".swiper_accessoires_wrapper-outer")
    ?.addEventListener("scroll", window.updateArrows);

  window.addEventListener("load", window.updateArrows);
  window.addEventListener("resize", window.updateArrows);

  $(document).on("keydown.videoPopup", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) closeMobileVideo();
  });

  $(document).on("click", ".product-single__thumbnail", function (event) {
    const ariaLabel = $(this).closest(".swiper-slide").attr("aria-label") || "";
    var firstNumber = parseInt(ariaLabel.trim(), 10);
    firstNumber = firstNumber - 1;
    console.log(firstNumber);
    window.pdpSwiper.slideTo(firstNumber);
  });

  $(".banner-small_button").click(function () {
    var dataTrigger = $(this).attr("data-value");
    $("html, body").animate(
      {
        scrollTop: $("" + dataTrigger + "").offset().top - 50,
      },
      500
    );
  });

  $(".mob_banner-smalle-clickable").click(function () {
    var dataTrigger = $(this).attr("data-value");
    $("html, body").animate(
      {
        scrollTop: $("" + dataTrigger + "").offset().top - 50,
      },
      500
    );
  });

  $(".card__wrapper").click(function (evt) {
    evt.preventDefault();
  });

  $(document).on("click", ".add--one--modal__handler--label", function (event) {
    $(".add--one--modal__handler--label").css("pointer-events", "none");
    setTimeout(function () {
      $(".add--one--modal__handler--label").css("pointer-events", "unset");
    }, 1000);
  });


  function detectAwinSession() {
  var params = new URLSearchParams(window.location.search);

  if (
    params.get('awc') ||
    params.get('source') === 'aw' ||
    params.get('sv1') === 'affiliate'
  ) {
    sessionStorage.setItem('awinSession', 'true');
  }
}
detectAwinSession();


function setAwinCookieIfAffiliate() {
  var params = new URLSearchParams(window.location.search);

  var isAwin =
    params.get('source') === 'aw' ||
    params.get('utm_source') === 'awin' ||
    params.has('awc') ||
    params.get('sv1') === 'affiliate';

  // Only set cookie if not already present
  if (isAwin && !document.cookie.includes('awinFirst=')) {

    // 30 days = 30 * 24 * 60 * 60 seconds
    var maxAge = 30 * 24 * 60 * 60;

    document.cookie =
      'awinFirst=true; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }
}

setAwinCookieIfAffiliate();

$(".product_spec_box-line-value span").click(function (e) {
    e.preventDefault();
    window.location.href = '/pages/warranty';
    // if (!$("#pdp-assembly-tab").hasClass("active")) {
    //   $("#pdp-assembly-tab").trigger("click");
    // }
    // $("html, body").animate(
    //   {
    //     scrollTop: $("#pdp-assembly-tab").offset().top - 200,
    //   },
    //   500,
    // );
  });

  $('[data-nav="warranty"]').click(function (e) {
    e.preventDefault();
    if (!$("#pdp-assembly-tab").hasClass("active")) {
      $("#pdp-assembly-tab").trigger("click");
    }
    $("html, body").animate(
      {
        scrollTop: $("#pdp-assembly-tab").offset().top - 200,
      },
      500,
    );
  });

  $('[data-warranty="true"]').click(function (e) {
    e.preventDefault();
    if (!$("#pdp-assembly-tab").hasClass("active")) {
      $("#pdp-assembly-tab").trigger("click");
    }
    $("html, body").animate(
      {
        scrollTop: $("#pdp-assembly-tab").offset().top - 200,
      },
      500,
    );
  });

});
